import React, { useState } from 'react';
import { getChartColors } from '@/utils/chartColors';

const LocationAnalytics = () => {
  // Dummy data for marketing sources
  const marketingSourceData = [
    { type: 'University Careers Service', value: 617 },
    { type: 'Company Website', value: 308 },
    { type: 'Dartmouth Partners', value: 231 },
    { type: 'Milkround', value: 78 },
    { type: 'Word of Mouth', value: 78 },
    { type: 'On-campus Societies', value: 78 },
    { type: 'Internal Referral', value: 78 },
    { type: 'Internship', value: 78 },
    { type: 'Facebook', value: 78 },
    { type: 'LinkedIn', value: 78 },
  ];

  const currentData = marketingSourceData;
  const total = currentData.reduce((sum, item) => sum + item.value, 0);

  // Use the new chart color palette
  const colors = getChartColors(currentData.length);

  return (
    <div className="bg-card rounded-lg shadow-lg p-6 h-full">
      <h2 className="text-xl font-semibold mb-4">Marketing sources</h2>
      
      {/* Range Chart */}
      <div className="space-y-4">
        {currentData.map((item, index) => {
          const percentage = (item.value / total) * 100;
          return (
            <div key={item.type} className="space-y-1 pb-2 border-b last:border-b-0">
              <div className="flex justify-between text-sm">
                <span className="text-muted-foreground font-medium">{item.type}</span>
                <span className="text-muted-foreground">{item.value} ({percentage.toFixed(1)}%)</span>
              </div>
              <div className="h-4 bg-muted rounded-full overflow-hidden">
                <div
                  className="h-full transition-all duration-500 ease-out"
                  style={{ 
                    width: `${percentage}%`,
                    backgroundColor: colors[index % colors.length]
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LocationAnalytics; 